//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Header_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Header_FIN.interface';



@Component({
    selector: 'app-edit-headers-lib-fin',
    templateUrl: './edit-headers-lib-fin.component.html',
    styleUrls: ['./edit-headers-lib-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/HeaderGlobal.css'],
    standalone: false
})
export class EditHeadersLibFINComponent implements OnInit {


  private ServiceFIN = inject(LibraryFINService);

  //-========================= SECTION VARIABLES =========================-\\

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR GENERAL COMPONENT ==================+\\
  public FIN_Headers: Header_FIN[] = [];

  ngOnInit(): void {
    this.Load_Component();
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component(): Promise<void> {


    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResGetHeaders: Response_FIN = await firstValueFrom(this.ServiceFIN.Get_Headers_Edit());

      if (ResGetHeaders.success) {

        this.FIN_Headers = ResGetHeaders.operation;

        Loader.classList.remove('active');
      }

    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      Loader.classList.remove('active');
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR DROP ITEM ==================-\\
  public drop(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.FIN_Headers, event.previousIndex, event.currentIndex);
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR SAVE CHANGES IN HEADERS =====================&\\

  //-================== FUNCTTION FOR SAVED HEADERS ==================-\\
  public SaveHeaders(): void {

    Swal.fire({
      title: '¿Desea guardar los cambios de las cabeceras de Finance Processes?',
      text: "¡Modificara el orden y los nombres en caso de que haya hecho cambios!",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, guardar',
      cancelButtonText: 'No, Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {

        try {

          for (let i = 0; i < this.FIN_Headers.length; i++) {
            const Header = this.FIN_Headers[i];
            Header.Position = i;
          }

          const ResUpdate: any = await firstValueFrom(this.ServiceFIN.Edit_Headers({ Headers: this.FIN_Headers }));


          if (ResUpdate.success) {
            Swal.fire({
              icon: 'success',
              title: 'Cabeceras modificadas correctamente ',
              confirmButtonColor: this.ColorConfirm
            })
          } else {
            throw "";
          }


        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Ocurrió un error al actualizar las cabeceras, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }

        this.Load_Component();

      }
    })

  }

  //&===================== END FUNCTIONS FOR SAVE CHANGES IN HEADERS =====================&\\

}
